import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "src/app/app.config";
import { ConfirmDialogComponent, ConfirmDialogModel } from "src/app/shared/components/confirm-dialog/confirm-dialog.component";
import { MonthClosureService } from "src/app/shared/service/month-closure.service";
import { UserService } from "src/app/shared/service/user.service";
import { isNullOrUndefined } from "util";

@Component({
  selector: "app-hr-deduction-details",
  templateUrl: "./hr-deduction.details.component.html",
  styleUrls: ["./hr-deduction.details.component.css"],
})
export class HRDeductionDetailsComponent implements OnInit {
  deductionDataSource: MatTableDataSource<any>;
  deductiondisplayedColumns: string[] = [
    "NamePerRecords",
    "LocationName",
    "Department",
    "CadreName",
    "DeductionDescription",
    "DeductionAmount",
    "remove",
  ];
  error: string;
  vendorList = [];
  employeeList = [];
  employeeDetails = [];
  currentMonth = "";
  currentFY = "";
  isFreeze = true;
  deductionFrom: any;
  @ViewChild("deductionpaginatorAll", { static: true })
  deductionpaginatorAll: MatPaginator;
  @ViewChild("deductionsortAll", { static: true }) deductionsortAll: MatSort;
  constructor(
    private _service: MonthClosureService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private deductionFormBuilder: FormBuilder,
    private dialog: MatDialog,
  ) {
    this.deductionFrom = this.deductionFormBuilder.group({
      deductionDetails: this.deductionFormBuilder.array([],this.duplicateRowValidator),
    });
    this.deductionDataSource = new MatTableDataSource();
  }
  ngOnInit() {
    //this.getDeductionDetails();
  }
  create() {
    var row = {
      NamePerRecords: "",
      LocationName: "",
      Department: "",
      CadreName: "",
      DeductionDescription: "",
      DeductionAmount: "",
      remove: "",
      DeductionId:0
    };
    return row;
  }
  deductionemployeeSelectd(event, row) {
    row.EmpCode = event.option.id;
    var emp = this.employeeDetails.filter(
      (c) => c.EmpCode == event.option.id
    )[0];
    row.LocationName = emp.LocationName;
    row.Department = emp.Department;
    row.CadreName = emp.CadreName;
    row.FY = this.currentFY;
    row.Month = this.currentMonth;

    row.NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
  }
  doFilterOnEmployee(element) {
    if (!isNullOrUndefined(element.NamePerRecords)) {
      this.employeeList = this.filterEmployee(
        this.employeeDetails,
        element.NamePerRecords
      );
      //element.id = 0;
    }
  }
  filterEmployee(values, NamePerRecords) {
    return values.filter((value) =>
      value.NamePerRecords && value.NamePerRecords !== ""
        ? value.NamePerRecords.toLowerCase().includes(NamePerRecords.toLowerCase()) ||
        value.EmpCode.toString().includes(NamePerRecords)
        : false
    );
  }
  duplicateRowValidator = (formArray: any): { [key: string]: any } | null => {
    const rows = (formArray as FormArray).controls;
    let values = rows.map(row => row.get('NamePerRecords')!=null && row.status!='DISABLED'?row.get('NamePerRecords').value+"-"+row.get('DeductionDescription').value:null);
   // let values = rows.map(row => row.get('NamePerRecords')!=null ?row.get('NamePerRecords').value:null);
    // if(!!values)
    //   {
    //     values=values.filter(c=>c.IsActive!=true)
    //   }
    //const items = this.deductionFrom.get("deductionDetails")as FormArray;
    values=values.filter(item => item !== null);
    if(!!values)
    {
    const duplicates = values.filter((value, index) => values.indexOf(value) !== index);

    rows.forEach(row => {

      const valueControl = row.get('NamePerRecords');
     const valuePurposeControl = row.get('DeductionDescription');
     
      if (valueControl && valueControl.value!="" &&  duplicates.length>0) {
        valueControl.setErrors(duplicates[0].includes(valueControl.value) && duplicates[0].includes(valuePurposeControl.value)? { duplicate: true } : null);
        valuePurposeControl.setErrors(duplicates[0].includes(valueControl.value) && duplicates[0].includes(valuePurposeControl.value) ? { duplicate: true } : null);
      }
      else{
        valueControl.setErrors(null);
        if (valueControl && valueControl.value=="")
        valueControl.setErrors({ required: true });
        valuePurposeControl.setErrors(null);
        if (valuePurposeControl && valuePurposeControl.value=="")
          valuePurposeControl.setErrors({ required: true });
       }
    });

    return duplicates.length > 0 ? { duplicate: true } : null;
  }
  return null;
  };

  removeAt($event:any,index: number, row: any) {
    const message = "Are you sure you want to delete this record?";
    const dialogData = new ConfirmDialogModel("Confirm Delete", message, "Submit", "OK", "Cancel");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "500px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe((dialogResult) => {
      if (dialogResult) {
    $event.preventDefault(); 
    const data = this.deductionDataSource.data;
    if (!!row && row.DeductionId > 0) 
      {
        row.IsActive = true;
        var result = this.deductionDataSource.data.filter(s => s.IsActive==true);
      if (result != null && result.length > 0) {
        result[0].LoginUserName = this._userService.getEmail();
        result[0].IsFreezed = this.isFreeze;
        this._service.saveDectionDetails(result).subscribe(
          (data: any[]) => {
            this.toastr.success("Deleted Successfully");
            const items = this.deductionFrom.get("deductionDetails")as FormArray;
            // Remove the control at the specified index
             items.removeAt(index);
            this.deductionDataSource.data = this.deductionDataSource.data.filter(s => s.IsActive!=true );
          },
          (error) => (this.error = error)
        );
      }
      }
    else 
    {data.splice(index, 1);
      const items = this.deductionFrom.get("deductionDetails")as FormArray;
      // Remove the control at the specified index
       items.removeAt(index);
      this.deductionDataSource.data = data.filter(s => s.IsActive!=true );
      
    }

    // this.deductionDataSource.data = data.filter(s => s.IsActive!=true );
    // let validationArray = this.deductionFormBuilder.array([],this.duplicateRowValidator);

    // this.deductionDataSource.data.forEach((detail) => {
    //  if (detail.IsActive != true)
    //    validationArray.push(this.createDeductionFormGroup(detail));
    // });
    // this.deductionFrom.setControl("deductionDetails", validationArray);
  }
});
  }
  addRow() {
    this.deductionDataSource.data.push(this.create());
    this.deductionDataSource.filter = "";
    let validationArray = this.deductionFormBuilder.array([],this.duplicateRowValidator);

    this.deductionDataSource.data.forEach((detail) => {
      validationArray.push(this.createDeductionFormGroup(detail));
    });
    this.deductionFrom.setControl("deductionDetails", validationArray);
  }
  getDeductionDetails() {
    this.deductionDataSource.data = [];
    this._service.getDeductionDetails(this.currentMonth).subscribe(
      (data: any[]) => {
        this.deductionDataSource.data = [];
        let validationArray = this.deductionFormBuilder.array([],this.duplicateRowValidator);
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            var emp = this.employeeDetails.filter(
              (c) => c.EmpCode == data[i].EmpCode
            )[0];
            if(emp!=null)
            {
              if(data[i].IsFromJoiners)
              {
                data[i].LocationName = emp.LocationName;
                data[i].Department = emp.Department
                data[i].CadreName = emp.CadreName;
              }
              else{
            data[i].LocationName = data[i].Location;
            data[i].Department = data[i].Department;
            data[i].CadreName = data[i].Cadre;
              }
            if(!!emp)
            data[i].NamePerRecords = `${emp.EmpCode} - ${emp.NamePerRecords}`;
            validationArray.push(this.createDeductionFormGroup(data[i]));
            }
          }
          if (this.isFreeze == false) {
            this.isFreeze = data[0].IsFreezed;
          }
          this.deductionFrom.setControl("deductionDetails", validationArray);
        }
        this.deductionDataSource.data = data;
        this.deductionDataSource.paginator = this.deductionpaginatorAll;
        this.deductionDataSource.sort = this.deductionsortAll;
      },
      (error) => (this.error = error)
    );
  }
  changed(row) {
    row.IsUpdated = true;
  }
  saveDectionDetails() {
    {

      if (this.deductionFrom.invalid) {
        this.toastr.warning("Please fill in the required fields");
        this.deductionFrom.markAllAsTouched();
        return;
      }
      var result = this.deductionDataSource.data.filter(s =>s.IsFromJoiners!=true&&(s.IsActive==false ||s.IsActive==null || s.IsActive==undefined ));
      //.filter(
      //   (s) => s.IsUpdated == true
      // );
      if (result != null && result.length > 0) {
        result[0].LoginUserName = this._userService.getEmail();
        result[0].IsFreezed = this.isFreeze;
        this._service.saveDectionDetails(result).subscribe(
          (data: any[]) => {


            this.toastr.success("Saved Successfully");
            this.getDeductionDetails();
          },
          (error) => (this.error = error)
        );
      }
    }
  }
  private createDeductionFormGroup(item: any): FormGroup {
    if(this.isFreeze==null)
      this.isFreeze=false;
    return new FormGroup({
      DeductionDescription: new FormControl({value:item.DeductionDescription,disabled: this.isFreeze==false?item.IsFromJoiners:this.isFreeze}, [
        Validators.required,
      ]),
      NamePerRecords: new FormControl({value:item.NamePerRecords,disabled: this.isFreeze==false?item.IsFromJoiners:this.isFreeze}, [
        Validators.required,
      ]),
      DeductionAmount: new FormControl({value:item.DeductionAmount,disabled: this.isFreeze==false?item.IsFromJoiners:this.isFreeze},  [  Validators.required,Validators.pattern("(?!0$)\\d{1,9}?$")]),
    });
  }
}
